// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__bv16B","bottom":"Footer_bottom__IA0+Y","b_right":"Footer_b_right__Kl2Ol","b_center":"Footer_b_center__YjNBp","link":"Footer_link__c7GbB"};